const convertPrice = (value, currency, exchanges) => {
  const vsCurrency = currency === 'eur' ? 'usd' : 'eur';
  const exchangesKey = `${currency}-to-${vsCurrency}`;
  const rate = exchanges[exchangesKey];
  const next = value * rate;
  return next;
};

export default convertPrice;
